import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined'
import { useFormatMessage } from '@/translations/useFormatMessage'
import { CartButtonRoot, CartBadge } from './CartButton.styled'

interface CartButtonProps {
	itemCount: number
	onClick: () => void
}

export function CartButton({ itemCount, onClick }: CartButtonProps) {
	const { t } = useFormatMessage()

	return (
		<CartButtonRoot
			onClick={onClick}
			data-testid="cart-button"
			aria-label={t('component:cartButton:ariaLabel', { itemCount })}
		>
			<ShoppingCartOutlinedIcon sx={{ fontSize: 20 }} />
			{itemCount > 0 && (
				<CartBadge data-testid="cart-badge" aria-hidden="true">
					{itemCount}
				</CartBadge>
			)}
		</CartButtonRoot>
	)
}
